import { JobRating } from "../../../common/JobOrder";
import formData from "./formData";

const {
    formField: {
        createdDate,
        dueDate,
        startDate,
        endDate,
        vessel,
        assignee,
        mariner,
        marinerLeavingFrom,
        marinerDestination,
        marinerTravelTimestamp,
        marinerAccomodation,
        marinerPickupDate,
        marinerDropoffDate,
        comments,
        marinerTwicTsaNum,
        marinerDateOfBirth,
        checklistRoot,
        travelDocuments,
        rating,
        flightNotice,
        trainingLocation,
        training,
        daysToBePaid,
        note,
    }
} = formData;

const initialValues = {
    [createdDate.name]: "",
    [dueDate.name]: "",
    [startDate.name]: "",
    [endDate.name]: "",
    [vessel.name]: undefined,
    [assignee.name]: undefined,
    [mariner.name]: undefined,
    [marinerLeavingFrom.name]: "",
    [marinerDestination.name]: "",
    [marinerTravelTimestamp.name]: "",
    [marinerAccomodation.name]: "",
    [marinerPickupDate.name]: "",
    [marinerDropoffDate.name]: "",
    [comments.name]: "",
    [marinerTwicTsaNum.name]: "",
    [marinerDateOfBirth.name]: "",
    [checklistRoot.name]: undefined,
    [travelDocuments.name]: [],
    [rating.name]: JobRating._Master,
    [flightNotice.name]: undefined,
    [trainingLocation.name]: undefined,
    [training.name]: undefined,
    [daysToBePaid.name]: "",
    [note.name]: "",
}

export default initialValues;